module.exports = __webpack_public_path__ + "img/49.4.NH3-N.28136ed5.png";